/* import __COLOCATED_TEMPLATE__ from './example-question-suggestion.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();